<template>
    <div class="container">
        <b-modal
            :model-value="showNewAjuste"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            :title="f_titulo()"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog create-ajuste-dialog"
            size="lg"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title" style="font-size: 16px; font-weight: 600; color: #2e507a;">{{ labels.infoTitle }}</div>
                    <div class="password-policy-subtitle" style="font-size: 14px; color: #6c757d;">{{ labels.infoText }}</div>
                </div>

                <!-- ORIGEN -->
                <div class="section-title mb-3">
                    <h6 class="section-header-text" style="font-size: 15px; font-weight: 600; color: #2e507a;">{{ labels.origen }}</h6>
                    <hr class="my-1" style="border-top: 1px solid #e9ecef;">
                </div>

                <b-row class="d-flex align-items-center uniform-form-row" style="margin-bottom: 10px;">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label" style="font-size: 14px; font-weight: 500; color: #495057;">{{ labels.company }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select 
                            v-model="selCompanyOrig" 
                            class="form-input"
                            style="height: 36px; font-size: 14px;"
                        >
                            <option value="">{{ labels.select }}</option>
                            <option v-for="comp in listCompany" :key="comp.id" :value="comp.id">
                                {{ comp.acronym + '-' + comp?.nombre }}
                            </option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row" style="margin-bottom: 10px;">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label" style="font-size: 14px; font-weight: 500; color: #495057;">{{ labels.eliminacion }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select 
                            v-model="selEliminacion" 
                            class="form-input"
                            style="height: 36px; font-size: 14px;"
                            @change="onEliminacionChange"
                        >
                            <option value="">{{ labels.select }}</option>
                            <option value="1">{{ labels.intNoContr }}</option>
                            <option value="2">{{ labels.elimInversion }}</option>
                            <option value="3">{{ labels.elimSaldoRecip }}</option>
                            <option value="4">{{ labels.ajusteCombina }}</option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row" style="margin-bottom: 10px;">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label" style="font-size: 14px; font-weight: 500; color: #495057;">{{ labels.type }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="tipoOrig" 
                            type="text" 
                            class="form-input"
                            style="height: 36px; font-size: 14px;"
                            autocomplete="off"
                            :placeholder="labels.typePlaceholder"
                            maxlength="100"
                        />
                    </b-col>
                </b-row>

                <!-- Criterio Origen -->
                <b-row v-if="showCuentaOrig && selEliminacion !== ''" class="uniform-form-row" style="margin-bottom: 10px;">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label" style="font-size: 14px; font-weight: 500; color: #495057;">
                            {{ labels.criterio }}
                        </label>
                    </b-col>

                    <b-col cols="12" md="8" class="text-left">
                        <div class="criterio-inputs-wrapper">
                            <b-form-input 
                                v-model="critCuenta" 
                                type="text" 
                                class="form-input"
                                style="height: 34px; font-size: 13px; margin-bottom: 6px;"
                                autocomplete="off"
                                :placeholder="labels.accountPlaceholder"
                                @input="buscaCuenta"
                            />

                            <b-form-input 
                                v-model="critDescripcion" 
                                type="text" 
                                class="form-input"
                                style="height: 34px; font-size: 13px;"
                                autocomplete="off"
                                :placeholder="labels.descriptionPlaceholder"
                                @input="buscaDescripcion"
                            />
                        </div>
                    </b-col>
                </b-row>

                <!-- Cuentas Origen -->
                <div v-if="showCuentaOrig && selEliminacion !== ''" class="accounts-section mt-2">
                    <div v-if="listCuentasSelMul?.length > 0" class="accounts-list mt-1">
                        <div class="select-all-container mb-2">
                            <b-button 
                                size="sm"
                                style="background-color: #2e507a; border-color: #2e507a; font-size: 13px; padding: 4px 16px; border-radius: 4px; color: white;"
                                @click="toggleSelectAllOrig"
                            >
                                {{ selectAllOrig ? labels.deselectAll : labels.selectAll }}
                            </b-button>
                        </div>

                        <div class="custom-scroll-table" style="min-height: 180px; height: auto; max-height: 180px; overflow-y: auto;">
                            <table class="table table-sm table-hover" style="font-size: 13px; margin-bottom: 0;">
                                <thead style="position: sticky; top: 0; background: #f8f9fa; z-index: 1;">
                                    <tr>
                                        <th style="width: 100px; font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">{{ labels.account }}</th>
                                        <th style="font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">{{ labels.description }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr 
                                        v-for="(cuenta, idx) in listCuentasSelMul" 
                                        :key="idx + '-' + cuenta.id"
                                        @click="toggleAccountSelection(cuenta, 'orig')"
                                        :class="{'table-active-blue': cuenta._selected}"
                                        style="cursor: pointer; border-radius: 8px;"
                                    >
                                        <td style="padding: 5px 8px; border-radius: 8px 0 0 8px;"><strong>{{ cuenta?.cuenta }}</strong></td>
                                        <td style="padding: 5px 8px; border-radius: 0 8px 8px 0;" :title="cuenta.descripcion">{{ cuenta?.descripcion }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div v-else-if="selCompanyOrig && !loadingCuentas" class="text-center py-2" style="height: 180px; display: flex; align-items: center; justify-content: center;">
                        <span class="text-muted" style="font-size: 13px;">{{ labels.noAccountsFound }}</span>
                    </div>

                    <div v-else-if="loadingCuentas" class="text-center py-2" style="height: 180px; display: flex; align-items: center; justify-content: center;">
                        <b-spinner small class="mr-1"></b-spinner>
                        <span style="font-size: 13px;">{{ labels.loading }}</span>
                    </div>
                </div>

                <!-- DESTINO -->
                <div v-if="showDestino && (selEliminacion === '2' || selEliminacion === '3' || selEliminacion === '4')" class="section-title mt-3 mb-2">
                    <h6 class="section-header-text" style="font-size: 15px; font-weight: 600; color: #2e507a;">{{ labels.destino }}</h6>
                    <hr class="my-1" style="border-top: 1px solid #e9ecef;">
                </div>

                <template v-if="showDestino && (selEliminacion === '2' || selEliminacion === '3' || selEliminacion === '4')">
                    <b-row class="d-flex align-items-center uniform-form-row" style="margin-bottom: 10px;">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label" style="font-size: 14px; font-weight: 500; color: #495057;">{{ labels.company }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-select 
                                v-model="selCompanyDest" 
                                class="form-input"
                                style="height: 36px; font-size: 14px;"
                            >
                                <option value="">{{ labels.select }}</option>
                                <option v-for="comp in listCompany" :key="comp.id" :value="comp.id">
                                    {{ comp?.acronym + '-' + comp?.nombre }}
                                </option>
                            </b-form-select>
                        </b-col>
                    </b-row>

                    <b-row class="d-flex align-items-center uniform-form-row" style="margin-bottom: 10px;">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label" style="font-size: 14px; font-weight: 500; color: #495057;">{{ labels.type }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-input 
                                v-model="tipoDest" 
                                type="text" 
                                class="form-input"
                                style="height: 36px; font-size: 14px;"
                                autocomplete="off"
                                :placeholder="labels.typePlaceholder"
                                maxlength="100"
                            />
                        </b-col>
                    </b-row>

                    <!-- Criterio Destino - IGUAL QUE EL ORIGEN -->
                    <b-row class="uniform-form-row" style="margin-bottom: 10px;">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label" style="font-size: 14px; font-weight: 500; color: #495057;">
                                {{ labels.criterio }}
                            </label>
                        </b-col>

                        <b-col cols="12" md="8" class="text-left">
                            <div class="criterio-inputs-wrapper">
                                <b-form-input 
                                    v-model="critCuentaDest" 
                                    type="text" 
                                    class="form-input"
                                    style="height: 34px; font-size: 13px; margin-bottom: 6px;"
                                    autocomplete="off"
                                    :placeholder="labels.accountPlaceholder"
                                    @input="buscaCuentaDest"
                                />

                                <b-form-input 
                                    v-model="critDescripcionDest" 
                                    type="text" 
                                    class="form-input"
                                    style="height: 34px; font-size: 13px;"
                                    autocomplete="off"
                                    :placeholder="labels.descriptionPlaceholder"
                                    @input="buscaDescripcionDest"
                                />
                            </div>
                        </b-col>
                    </b-row>
                </template>

                <!-- Cuentas Destino -->
                <div v-if="showCuentaDest && (selEliminacion === '2' || selEliminacion === '3' || selEliminacion === '4')" class="accounts-section mt-2">
                    <div v-if="listCuentasSelMulDest?.length > 0" class="accounts-list mt-1">
                        <div class="select-all-container mb-2">
                            <b-button 
                                size="sm"
                                style="background-color: #2e507a; border-color: #2e507a; font-size: 13px; padding: 4px 16px; border-radius: 4px; color: white;"
                                @click="toggleSelectAllDest"
                            >
                                {{ selectAllDest ? labels.deselectAll : labels.selectAll }}
                            </b-button>
                        </div>

                        <div class="custom-scroll-table" style="min-height: 180px; height: auto; max-height: 180px; overflow-y: auto;">
                            <table class="table table-sm table-hover" style="font-size: 13px; margin-bottom: 0;">
                                <thead style="position: sticky; top: 0; background: #f8f9fa; z-index: 1;">
                                    <tr>
                                        <th style="width: 100px; font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">{{ labels.account }}</th>
                                        <th style="font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">{{ labels.description }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr 
                                        v-for="(cuenta, idx) in listCuentasSelMulDest" 
                                        :key="idx + '-' + cuenta.id"
                                        @click="toggleAccountSelection(cuenta, 'dest')"
                                        :class="{'table-active-blue': cuenta._selected}"
                                        style="cursor: pointer; border-radius: 8px;"
                                    >
                                        <td style="padding: 5px 8px; border-radius: 8px 0 0 8px;"><strong>{{ cuenta?.cuenta }}</strong></td>
                                        <td style="padding: 5px 8px; border-radius: 0 8px 8px 0;" :title="cuenta.descripcion">{{ cuenta?.descripcion }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div v-else-if="selCompanyDest && !loadingCuentasDest" class="text-center py-2" style="height: 180px; display: flex; align-items: center; justify-content: center;">
                        <span class="text-muted" style="font-size: 13px;">{{ labels.noAccountsFound }}</span>
                    </div>

                    <div v-else-if="loadingCuentasDest" class="text-center py-2" style="height: 180px; display: flex; align-items: center; justify-content: center;">
                        <b-spinner small class="mr-1"></b-spinner>
                        <span style="font-size: 13px;">{{ labels.loading }}</span>
                    </div>
                </div>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="mr-2 reset-btn-secondary" @click="closeModal" :disabled="isSaving" style="font-size: 14px; padding: 6px 24px;">{{ labels.close }}</b-button>
                    <b-button class="reset-btn-primary" @click="guardaAjuste" :disabled="isSaving" style="font-size: 14px; padding: 6px 24px;">
                        {{ isSaving ? labels.saving : labels.save }}
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Company from '../../services/Company'
import PlanCuentas from '../../services/PlanCuentas'
import BalanceNiif from '../../services/BalanceNiif'
import Ajustes from '../../services/AjustesConsol'

export default {
    name: "NewAjuste",
    props: ['showNewAjuste', 'vigenciaSelect'],
    data: () => ({
        // Datos origen
        selCompanyOrig: "",
        listCompany: [],
        showCuentaOrig: false,
        listCuentasOrig: [],
        listCuentasSelMul: [],
        tipoOrig: "",
        loadingCuentas: false,

        // Datos destino
        selCompanyDest: "",
        showCuentaDest: false,
        listCuentasDest: [],
        listCuentasSelMulDest: [],
        tipoDest: "",
        loadingCuentasDest: false,

        // Estado general
        showDestino: false,
        selEliminacion: "",

        // Filtros
        critCuenta: "",
        critDescripcion: "",
        critCuentaDest: "",
        critDescripcionDest: "",

        // Checkboxes
        selectAllOrig: false,
        selectAllDest: false,
        listadoCuentasOrig: [],
        listadoCuentasDest: [],
        isSaving: false
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Ajuste",
                    infoTitle: "Ajustes de consolidación",
                    infoText: "Completa la información y guarda el nuevo ajuste.",
                    save: "Guardar",
                    saving: "Guardando...",
                    close: "Cerrar",
                    select: "Seleccione...",
                    company: "Compañía",
                    account: "Cuentas",
                    description: "Descripción",
                    criterio: "Criterio",
                    type: "Tipo",
                    typePlaceholder: "Ej: Tipo de ajuste",
                    accountPlaceholder: "Buscar por cuenta...",
                    descriptionPlaceholder: "Buscar por descripción...",
                    origen: "ORIGEN",
                    destino: "DESTINO",
                    eliminacion: "Eliminación",
                    intNoContr: "Interes no controlante",
                    elimInversion: "Eliminación en inversión",
                    elimSaldoRecip: "Eliminación saldo recíproco",
                    ajusteCombina: "Ajuste del combinado",
                    selected: "Seleccionadas",
                    selectAll: "Seleccionar todas",
                    deselectAll: "Deseleccionar todas",
                    available: "disponibles",
                    noAccountsFound: "No se encontraron cuentas",
                    loading: "Cargando cuentas..."
                }
            } else {
                return {
                    title: "Adjustment",
                    infoTitle: "Consolidation adjustments",
                    infoText: "Complete the information and save the new adjustment.",
                    save: "Save",
                    saving: "Saving...",
                    close: "Close",
                    select: "Select...",
                    company: "Company",
                    account: "Accounts",
                    description: "Description",
                    criterio: "Criterion",
                    type: "Type",
                    typePlaceholder: "Ex: Adjustment type",
                    accountPlaceholder: "Search by account...",
                    descriptionPlaceholder: "Search by description...",
                    origen: "ORIGIN",
                    destino: "DESTINATION",
                    eliminacion: "Elimination",
                    intNoContr: "Non-controlling interest",
                    elimInversion: "Investment elimination",
                    elimSaldoRecip: "Reciprocal balance elimination",
                    ajusteCombina: "Combined adjustment",
                    selected: "Selected",
                    selectAll: "Select all",
                    deselectAll: "Deselect all",
                    available: "available",
                    noAccountsFound: "No accounts found",
                    loading: "Loading accounts..."
                }
            }
        }
    },
    methods: {
        f_titulo() {
            return this.labels.title
        },

        onEliminacionChange() {
            console.log('Eliminación cambiada a:', this.selEliminacion)
            this.showDestino = (this.selEliminacion === '2' || this.selEliminacion === '3' || this.selEliminacion === '4')
            if (this.selEliminacion === '1') {
                this.selCompanyDest = ""
                this.showCuentaDest = false
                this.listCuentasDest = []
                this.listCuentasSelMulDest = []
                this.listadoCuentasDest = []
                this.tipoDest = ""
                this.selectAllDest = false
                if (this.selCompanyOrig) {
                    this.loadCuentas(this.selCompanyOrig, 'orig')
                }
            } else if (this.selEliminacion === '2' || this.selEliminacion === '3' || this.selEliminacion === '4') {
                if (this.selCompanyOrig) {
                    this.loadCuentas(this.selCompanyOrig, 'orig')
                }
            } else {
                this.showCuentaOrig = false
                this.listCuentasOrig = []
                this.listCuentasSelMul = []
                this.listadoCuentasOrig = []
            }
        },

        toggleAccountSelection(cuenta, type) {
            cuenta._selected = !cuenta._selected
            this.onAccountChange(cuenta, type)
        },

        buscaCuenta() {
            if (this.critCuenta.length == 0) {
                this.listCuentasSelMul = [...this.listCuentasOrig]
                return
            }
            const criterio = "^" + this.critCuenta
            this.listCuentasSelMul = this.listCuentasOrig.filter(
                (cuenta) => cuenta.cuenta && cuenta.cuenta.match(criterio)
            )
            this.updateSelectAll('orig')
        },

        buscaDescripcion() {
            if (this.critDescripcion.length == 0) {
                this.listCuentasSelMul = [...this.listCuentasOrig]
                return
            }
            const searchTerm = this.critDescripcion.toUpperCase()
            this.listCuentasSelMul = this.listCuentasOrig.filter(
                (cuenta) => cuenta.descripcion &&
                    cuenta.descripcion.toUpperCase().includes(searchTerm)
            )
            this.updateSelectAll('orig')
        },

        buscaCuentaDest() {
            if (this.critCuentaDest.length == 0) {
                this.listCuentasSelMulDest = [...this.listCuentasDest]
                return
            }
            const criterio = "^" + this.critCuentaDest
            this.listCuentasSelMulDest = this.listCuentasDest.filter(
                (cuenta) => cuenta.cuenta && cuenta.cuenta.match(criterio)
            )
            this.updateSelectAll('dest')
        },

        buscaDescripcionDest() {
            if (this.critDescripcionDest.length == 0) {
                this.listCuentasSelMulDest = [...this.listCuentasDest]
                return
            }
            const searchTerm = this.critDescripcionDest.toUpperCase()
            this.listCuentasSelMulDest = this.listCuentasDest.filter(
                (cuenta) => cuenta.descripcion &&
                    cuenta.descripcion.toUpperCase().includes(searchTerm)
            )
            this.updateSelectAll('dest')
        },

        toggleSelectAllOrig() {
            this.selectAllOrig = !this.selectAllOrig
            this.listCuentasSelMul.forEach(cuenta => {
                cuenta._selected = this.selectAllOrig
                if (this.selectAllOrig && !this.listadoCuentasOrig.includes(cuenta.cuenta)) {
                    this.listadoCuentasOrig.push(cuenta.cuenta)
                } else if (!this.selectAllOrig) {
                    const index = this.listadoCuentasOrig.indexOf(cuenta.cuenta)
                    if (index > -1) {
                        this.listadoCuentasOrig.splice(index, 1)
                    }
                }
            })
        },

        toggleSelectAllDest() {
            this.selectAllDest = !this.selectAllDest
            this.listCuentasSelMulDest.forEach(cuenta => {
                cuenta._selected = this.selectAllDest
                if (this.selectAllDest && !this.listadoCuentasDest.includes(cuenta.cuenta)) {
                    this.listadoCuentasDest.push(cuenta.cuenta)
                } else if (!this.selectAllDest) {
                    const index = this.listadoCuentasDest.indexOf(cuenta.cuenta)
                    if (index > -1) {
                        this.listadoCuentasDest.splice(index, 1)
                    }
                }
            })
        },

        onAccountChange(cuenta, type) {
            if (type === 'orig') {
                if (cuenta._selected && !this.listadoCuentasOrig.includes(cuenta.cuenta)) {
                    this.listadoCuentasOrig.push(cuenta.cuenta)
                } else if (!cuenta._selected) {
                    const index = this.listadoCuentasOrig.indexOf(cuenta.cuenta)
                    if (index > -1) {
                        this.listadoCuentasOrig.splice(index, 1)
                    }
                }
                this.updateSelectAll('orig')
            } else {
                if (cuenta._selected && !this.listadoCuentasDest.includes(cuenta.cuenta)) {
                    this.listadoCuentasDest.push(cuenta.cuenta)
                } else if (!cuenta._selected) {
                    const index = this.listadoCuentasDest.indexOf(cuenta.cuenta)
                    if (index > -1) {
                        this.listadoCuentasDest.splice(index, 1)
                    }
                }
                this.updateSelectAll('dest')
            }
        },

        updateSelectAll(type) {
            if (type === 'orig') {
                if (this.listCuentasSelMul.length === 0) {
                    this.selectAllOrig = false
                    return
                }
                this.selectAllOrig = this.listCuentasSelMul.every(cuenta => cuenta._selected)
            } else {
                if (this.listCuentasSelMulDest.length === 0) {
                    this.selectAllDest = false
                    return
                }
                this.selectAllDest = this.listCuentasSelMulDest.every(cuenta => cuenta._selected)
            }
        },

        async guardaAjuste() {
            if (this.isSaving) {
                return
            }
            const codReportePrincipal = await this.getReportePrincipal()
            if (!codReportePrincipal) {
                this.$toast.error('No se pudo obtener el reporte principal')
                return
            }
            if (this.selEliminacion === "2" || this.selEliminacion === "3" || this.selEliminacion === "4") {
                if (!this.selCompanyOrig) {
                    this.$toast.error('Diligenciar la compañía origen')
                    return
                }
                if (this.listadoCuentasOrig.length === 0) {
                    this.$toast.error('Seleccionar la(s) cuenta(s) origen')
                    return
                }
                if (!this.tipoOrig) {
                    this.$toast.error('Diligenciar el tipo origen')
                    return
                }
                if (!this.selCompanyDest) {
                    this.$toast.error('Diligenciar la compañía destino')
                    return
                }
                if (this.listadoCuentasDest.length === 0) {
                    this.$toast.error('Seleccionar la(s) cuenta(s) destino')
                    return
                }
                if (!this.tipoDest) {
                    this.$toast.error('Diligenciar el tipo destino')
                    return
                }
                let formOrig = {
                    'vigencia': this.vigenciaSelect,
                    'codReporte': codReportePrincipal,
                    'idCompany': this.selCompanyOrig,
                    'tipo': this.tipoOrig,
                    'cuenta': this.listadoCuentasOrig,
                    'eliminacion': this.selEliminacion,
                    'idCompanyDest': this.selCompanyDest,
                    'tipoDest': this.tipoDest,
                    'cuentaDest': this.listadoCuentasDest,
                    'idUser': this.$store.state.userId
                }
                await this.saveAdjustment(formOrig)
            } else if (this.selEliminacion === "1") {
                if (!this.selCompanyOrig) {
                    this.$toast.error('Diligenciar la compañía origen')
                    return
                }
                if (!this.tipoOrig) {
                    this.$toast.error('Diligenciar el tipo')
                    return
                }
                let formOrig = {
                    'vigencia': this.vigenciaSelect,
                    'codReporte': codReportePrincipal,
                    'idCompany': this.selCompanyOrig,
                    'tipo': this.tipoOrig,
                    'cuenta': this.listadoCuentasOrig,
                    'eliminacion': this.selEliminacion,
                    'idUser': this.$store.state.userId
                }
                await this.saveAdjustment(formOrig)
            } else {
                this.$toast.error('Seleccionar tipo de eliminación')
                return
            }
        },

        async saveAdjustment(formData) {
            if (this.isSaving) return
            this.isSaving = true
            try {
                const res = await BalanceNiif.ingresaElimAjusteOrig(formData)
                if (res.status == 200) {
                    this.$toast.success(res.status + " " + res.data.message)
                } else {
                    this.$toast.error("Error " + res.status + " al grabar")
                }
            } catch (err) {
                console.log(err)
                this.$toast.error("Error al guardar el ajuste")
            } finally {
                setTimeout(() => {
                    this.reloadTbl()
                    this.isSaving = false
                }, 1500)
            }
        },

        reloadTbl() {
            this.resetForm()
            this.$emit('reloadTbl', this.vigenciaSelect)
        },

        resetForm() {
            this.selCompanyOrig = ""
            this.showCuentaOrig = false
            this.listCuentasOrig = []
            this.listCuentasSelMul = []
            this.listadoCuentasOrig = []
            this.tipoOrig = ""
            this.selectAllOrig = false
            this.loadingCuentas = false

            this.selCompanyDest = ""
            this.showCuentaDest = false
            this.listCuentasDest = []
            this.listCuentasSelMulDest = []
            this.listadoCuentasDest = []
            this.tipoDest = ""
            this.selectAllDest = false
            this.loadingCuentasDest = false

            this.selEliminacion = ""
            this.showDestino = false

            this.critCuenta = ""
            this.critDescripcion = ""
            this.critCuentaDest = ""
            this.critDescripcionDest = ""
        },

        closeModal() {
            if (this.isSaving) {
                return
            }
            this.resetForm()
            this.$emit('closeModal', false)
        },

        async getReportePrincipal() {
            try {
                const response = await Ajustes.getReportePrincipal()
                return response.data?.codigo
            } catch (error) {
                console.error('Error al obtener reporte principal:', error)
                return null
            }
        },

        async loadCuentas(idComp, type) {
            console.log('loadCuentas llamado:', idComp, type, 'eliminación:', this.selEliminacion)
            if (!this.selEliminacion) {
                console.log('No cargar cuentas - no hay eliminación seleccionada')
                if (type === 'orig') {
                    this.showCuentaOrig = false
                    this.listCuentasOrig = []
                    this.listCuentasSelMul = []
                } else {
                    this.showCuentaDest = false
                    this.listCuentasDest = []
                    this.listCuentasSelMulDest = []
                }
                return
            }
            if (type === 'dest' && this.selEliminacion !== '2' && this.selEliminacion !== '3' && this.selEliminacion !== '4') {
                console.log('No cargar cuentas destino - eliminación no es 2 o 3')
                this.showCuentaDest = false
                this.listCuentasDest = []
                this.listCuentasSelMulDest = []
                return
            }
            if (!idComp) {
                if (type === 'orig') {
                    this.showCuentaOrig = false
                    this.listCuentasOrig = []
                    this.listCuentasSelMul = []
                    this.listadoCuentasOrig = []
                    this.loadingCuentas = false
                } else {
                    this.showCuentaDest = false
                    this.listCuentasDest = []
                    this.listCuentasSelMulDest = []
                    this.listadoCuentasDest = []
                    this.loadingCuentasDest = false
                }
                return
            }
            if (type === 'orig') {
                this.loadingCuentas = true
            } else {
                this.loadingCuentasDest = true
            }

            const codReportePrincipal = await this.getReportePrincipal()
            if (!codReportePrincipal) {
                if (type === 'orig') {
                    this.loadingCuentas = false
                } else {
                    this.loadingCuentasDest = false
                }
                this.$toast.error('No se pudo obtener el reporte principal')
                return
            }

            try {
                const res = await PlanCuentas.getCuentasPorCompaVigRepor(
                    idComp,
                    this.vigenciaSelect,
                    codReportePrincipal
                )
                console.log('Respuesta del servicio para', type, ':', res.data)
                const cuentas = res.data.planCuentas || []
                console.log('Cuentas recibidas:', cuentas.length, 'para', type)
                cuentas.forEach(cuenta => {
                    cuenta._selected = false
                })
                if (type === 'orig') {
                    this.listCuentasOrig = cuentas
                    this.listCuentasSelMul = [...cuentas]
                    this.showCuentaOrig = true
                    this.listadoCuentasOrig = []
                    this.selectAllOrig = false
                } else {
                    this.listCuentasDest = cuentas
                    this.listCuentasSelMulDest = [...cuentas]
                    this.showCuentaDest = true
                    this.listadoCuentasDest = []
                    this.selectAllDest = false
                }
            } catch (err) {
                console.error('Error cargando cuentas para', type, ':', err)
                if (err.response && err.response.status === 400) {
                    this.$toast.warning(`La compañía seleccionada no tiene cuentas disponibles para la vigencia ${this.vigenciaSelect}`)
                }
                if (type === 'orig') {
                    this.showCuentaOrig = false
                    this.listCuentasOrig = []
                    this.listCuentasSelMul = []
                } else {
                    this.showCuentaDest = false
                    this.listCuentasDest = []
                    this.listCuentasSelMulDest = []
                }
            } finally {
                if (type === 'orig') {
                    this.loadingCuentas = false
                } else {
                    this.loadingCuentasDest = false
                }
            }
        }
    },
    mounted() {
        Company.getAllCompanies()
            .then((result) => {
                this.listCompany = result.data.companies || []
            })
            .catch((error) => {
                console.error('Error cargando compañías:', error)
                this.listCompany = []
            })
    },
    watch: {
        selCompanyOrig(idComp) {
            console.log('Compañía origen cambiada a:', idComp)
            if (this.selEliminacion) {
                this.loadCuentas(idComp, 'orig')
            } else {
                this.showCuentaOrig = false
                this.listCuentasOrig = []
                this.listCuentasSelMul = []
            }
        },

        selCompanyDest(idComp) {
            console.log('Compañía destino cambiada a:', idComp)
            if (this.selEliminacion === '2' || this.selEliminacion === '3' || this.selEliminacion === '4') {
                this.loadCuentas(idComp, 'dest')
            } else {
                this.showCuentaDest = false
                this.listCuentasDest = []
                this.listCuentasSelMulDest = []
            }
        },

        selEliminacion(newVal, oldVal) {
            console.log('Eliminación cambiada de', oldVal, 'a', newVal)
            this.onEliminacionChange()
        }
    }
}
</script>

<style src="../main.css"></style>

<style scoped>

.table-active {
    background-color: #e3f0ff !important;
}

.table-active:hover {
    background-color: #d4e8ff !important;
}

.select-all-text {
    cursor: pointer;
    font-size: 12px;
    color: #2e507a;
}

.select-all-text:hover {
    text-decoration: underline;
}

.table-active-blue {
    background-color: #e3f0ff !important;
    border-radius: 8px !important;
}

.table-active-blue td {
    background-color: #e3f0ff !important;
}

/* Quitar las rayitas de cuaderno de la tabla */
.table-responsive .table {
    border-collapse: separate !important;
    border-spacing: 0 4px !important;
}

.table-responsive .table tbody tr {
    border-radius: 8px !important;
    box-shadow: none !important;
}

.table-responsive .table tbody tr td {
    border: none !important;
}

/* Hover para las filas */
.table-responsive .table tbody tr:hover {
    background-color: #f5f9ff !important;
}

.table-responsive .table tbody tr:hover td {
    background-color: #f5f9ff !important;
}

/* Quitar bordes de las celdas */
.table-responsive .table td,
.table-responsive .table th {
    border: none !important;
}

.custom-scroll-table {
    height: 180px;
    min-height: 180px;
    max-height: 180px;
    overflow-y: auto;
    position: relative;
}

/* Estilo del scrollbar */
.custom-scroll-table::-webkit-scrollbar {
    width: 8px;
}

.custom-scroll-table::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.custom-scroll-table::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
}

.custom-scroll-table::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}
</style>